import {
    useGetDriversQuery as useGetDriversV2Query,
    useGetVehiclesQuery as useGetVehiclesV2Query,
} from '#api/resources.slice.ts';

export const useGetDriversQuery = useGetDriversV2Query;
export const useGetVehiclesQuery = useGetVehiclesV2Query;

export const useResources = () => {
    const { data: drivers, isLoading: driverLoading, refetch: refetchDrivers } = useGetDriversQuery();
    const { data: vehicles, isLoading: vehicleLoading, refetch: refetchVehicles } = useGetVehiclesQuery();

    return {
        isLoading: driverLoading || vehicleLoading,
        drivers: drivers || [],
        vehicles: vehicles || [],
        trailers: [],
        refetch: () => {
            refetchDrivers();
            refetchVehicles();
        },
    };
};
